// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pG6KD","field":"styles_field__20NmC","fieldCol":"styles_fieldCol__32JfG","diffCol":"styles_diffCol__2MyLg","diff":"styles_diff__3N92k"};